// Animations
import './animations/smoothScroll';
import './animations/scrollToFuncs';
import './animations/parallax';
import './animations/fadeInOnScroll';

// Global
import './global/navOverlay';
import './global/filters';
import './global/bookingPanel';
import './global/progressBar';
import './global/wpmlDropdown';
import './global/popups';
import './global/tooltips';
import './global/stickyHeader';

// Modules
import './modules/slider';
import './modules/latestOffers';
import './modules/contactForm';
import './modules/testimonials';

// Import main scss file here. This will compile to a css file in the dist folder
import '../scss/style.scss';
